import * as api from '../api/adapters/json_api';
import {update} from "../api/adapters/json_api";

const type = 'api_resources/tags';
export default {
  index: () => api.read({ type }, {query: {sort: 'name'}}),
  assignTag: (data) => api.update({ type, action: 'assign_tag' }, {}, data),
  removeTag: (data) => api.update({ type, action: 'remove_tag' }, {}, data),
}
